const TAG_SCHEMA = [
  'categories',
  'subcategories',
  'cities',
  'universities',
  'provinces',
];

export const DOM_CLASSES = [
  'DNADatum',
  'DNADatum-category',
  'TagListItem',
  'TagBarGraph',
];

function forEachNode(nodes, func) {
  Array.prototype.forEach.call(nodes, func);
}

export default class DomManipulator {
  constructor() {
    this.dnaGraph = null;

    this.tagIdParsers = {
      recommendations: node => node.dataset.id,
    };
    TAG_SCHEMA.forEach(
      schema => (this.tagIdParsers[schema] = this.tagIdParserFactory(schema))
    );
  }

  registerDNAGraph = () => {
    this.dnaGraph = document.getElementById('DNAGraph');
  };

  updateDom = state => {
    this.updateDNAGraph(state);
    this.updateDNACategories(state);
    this.updateRankedList(state, 'categories');
    this.updateRankedList(state, 'universities');
    this.updateTagList(state, 'subcategories');
    this.updateTagList(state, 'cities');
  };

  updateDNAGraph = state => {
    let schema = 'recommendations';
    let className = 'DNADatum';

    if (!this.dnaGraph) {
      return;
    }

    let idParser = this.tagIdParsers[schema];
    let entities = state[schema].entities;
    let nodes = this.dnaGraph.getElementsByClassName(className);

    if (state[schema].isActive) {
      forEachNode(nodes, node => {
        const id = idParser(node);
        if (entities.has(id)) {
          node.classList.add('highlighted');
          node.classList.remove('dimmed');
        } else {
          node.classList.remove('highlighted');
          node.classList.add('dimmed');
        }
      });
    } else {
      this.bulkRemoveDimming(this.dnaGraph, 'DNADatum');
      const highlightedNodes = this.dnaGraph.getElementsByClassName(
        'DNADatum highlighted'
      );
      while (highlightedNodes.item(0)) {
        highlightedNodes.item(0).classList.remove('highlighted');
      }
    }
  };

  updateDNACategories = state => {
    if (state['categories'].isActive) {
      // We only care about the categories that are not already dimmed.
      const categoryNodes = this.dnaGraph.querySelectorAll(
        '.DNADatum:not(.dimmed) .DNADatum-category'
      );
      this.updateNodes(
        state['categories'].entities,
        categoryNodes,
        this.tagIdParsers['categories']
      );
    } else {
      this.bulkRemoveDimming(this.dnaGraph, 'DNADatum-category');
    }
  };

  updateRankedList = (state, schema) => {
    const listHolder = document.getElementById(
      `PercentageRankedList-${schema}`
    );
    this.updateNodeClasses(state, schema, listHolder, 'TagBarGraph');
    this.updateOtherGraph(state, schema, listHolder);
  };

  updateTagList = (state, schema) => {
    const tagList = document.getElementById(`TagRankedList-${schema}`);
    this.updateNodeClasses(state, schema, tagList, 'TagListItem');
  };

  updateOtherGraph = (state, schema, parentNode) => {
    const otherGraphs = parentNode.getElementsByClassName(
      `RemainderBarGraph-${schema}`
    );
    if (state[schema].isActive && state[schema].otherIsDimmed) {
      forEachNode(otherGraphs, node => node.classList.add('dimmed'));
    } else {
      forEachNode(otherGraphs, node => node.classList.remove('dimmed'));
    }
  };

  // "Private"

  updateNodeClasses = (state, schema, parentNode, className) => {
    if (!parentNode) {
      return;
    }
    let idParser = this.tagIdParsers[schema];
    let idSet = state[schema].entities;
    let nodes = parentNode.getElementsByClassName(className);

    if (state[schema].isActive) {
      this.updateNodes(idSet, nodes, idParser);
    } else {
      this.bulkRemoveDimming(parentNode, className);
    }
  };

  updateNodes = (entities, nodes, idParser) => {
    forEachNode(nodes, node => {
      const id = idParser(node);
      if (entities.has(id)) {
        node.classList.remove('dimmed');
      } else {
        node.classList.add('dimmed');
      }
    });
  };

  bulkRemoveDimming = (rootNode, className) => {
    const dimmedNodes = rootNode.getElementsByClassName(className + ' dimmed');

    while (dimmedNodes.item(0)) {
      dimmedNodes.item(0).classList.remove('dimmed');
    }
  };

  tagIdParserFactory = schema => {
    return node => {
      return parseInt(node.dataset.id, 10);
    };
  };
}



// WEBPACK FOOTER //
// ./src/services/highlightingService/domManipulator.js